export const defaultInvoiceConfigValues = {
	title: 'Order Details',
	titleArabic: 'Order Details',
	templateName: 'template1',
	pageSize: 'A4',
	fontSize: '10px',
	fontWeight: 'regular',
	orderNumberBarcodeFormat: 'CODE128',
	barcodeSize: 'default',
	logoType: 'companyLogo',
	language: 'engValue',
	showQrCode: false,
	showBarcode: true,
	showOrderNumber: true,
	showOrderDate: true,
	showInvoiceCreatedDate: false,
	showDateOfShipmentArrival: false,
	showDeliveryCompany: true,
	showShipmentNumber: true,
	showPaymentMethod: true,
	showVatNumber: true,
	showCRNumber: true,
	showFullName: true,
	showPhoneNumber: true,
	showAddress: true,
	showCity: false,
	showCountry: false,
	showSenderName: true,
	showSenderAddress: false,
	showShippingDescription: true,
	showOrderItems: true,
	showTotalQuantity: false,
	showSubTotal: false,
	showDiscount: false,
	showCodFee: false,
	showShipFee: true,
	showShippingDiscount: true,
	showVatAmount: true,
	showTotalDue: true,
	showGrandTotal: true,
	showOrderComment: false,
	showCouponCode: false,
	columnSettings: [],
	showRef2: false
};

export const defaultBranchConfigValues = {
	title: 'Order Details',
	templateName: 'template1',
	pageSize: 'A6',
	fontSize: '10px',
	fontWeight: 'regular',
	orderNumberBarcodeFormat: 'CODE128',
	barcodeSize: 'default',
	language: 'engValue',
	showQrCode: false,
	showBarcode: true,
	showOrderNumber: true,
	showOrderDate: true,
	showInvoiceCreatedDate: false,
	showDateOfShipmentArrival: false,
	showDeliveryCompany: true,
	showShipmentNumber: true,
	showPaymentMethod: true,
	showVatNumber: true,
	showCRNumber: true,
	showFullName: true,
	showPhoneNumber: true,
	showAddress: true,
	showCity: false,
	showSenderName: true,
	showSenderAddress: false,
	showShippingDescription: false,
	showOrderItems: true,
	showTotalQuantity: false,
	showSubTotal: false,
	showDiscount: false,
	showCodFee: false,
	showShipFee: true,
	showVatAmount: true,
	showTotalDue: true,
	showGrandTotal: true,
	showOrderComment: false,
	showCouponCode: false,
	columnSettings: []
};

export const defaultAwbConfigValues = {
	showOrderItems: true,
	showOrderNumber: true,
	showOrderNumberBarcode: true,
	showOrderDate: true,
	showInvoiceCreatedDate: true,
	showPaymentMethod: true,
	showSenderAddress: true,
	showAddress: true,
	showDescription: true,
	showGrandTotal: true,
	showTotalDue: true,
	showShipmentDate: true,
	showShipmentNumber: true,
	showSerialNumber: false,
	showItemQuantity: false,
	showShippingDescription: true,
	showDriverName: false,
	showOrderComment: false,
	showCity: true,
	showRegion: false,
	showDistrict: false,
	showArea: true,
	pageSize: 'A6',
	fontSize: '10px',
	fontWeight: 'regular',
	shipmentNumberBarcodeFormat: 'CODE128',
	orderNumberBarcodeFormat: 'CODE128',
	showDeliveryCompanyLogo: true,
	language: 'engValue',
	templateName: 'template1',
	pageMarginHorizontal: null,
	pageMarginVertical: null,
	shipmentNumberBarcodeFullWidth: true,
	shipmentNumberBarcodeWidth: 1,
	shipmentNumberBarcodeHeight: 30,
	orderNumberBarcodeFullWidth: true,
	orderNumberBarcodeWidth: 1,
	orderNumberBarcodeHeight: 30,
	showSuccessMessage: true,
	showFooterOnTop: false,
	showRef1: false,
	showSenderPhoneNumber: true,
	showReceiverPhoneNumber: true,
	showOrderPlatform: false,
	hidePageNumber: true,
	hidePoweredByOto: false,
	numberOfCharactersPerItem: undefined,
	numberOfShownItems: undefined,
	showSortingCode: false
};
